
import { toFloat64 } from "./fable_modules/fable-library-js.5.3.0/BigInt.js";
import { toUnixTimeMilliseconds } from "./fable_modules/fable-library-js.5.3.0/DateOffset.js";
import { Clock_system } from "./Shared/Clock.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { disposeSafe, getEnumerator } from "./fable_modules/fable-library-js.5.3.0/Util.js";
import { singleton } from "./fable_modules/fable-library-js.5.3.0/List.js";

export const throttleMs = 30000;

/**
 * Reload only when both build ids are known, non-empty and different.
 */
export function needsReload(pageBuild_1, serverBuild) {
    let matchResult, page_1, server_1;
    if (pageBuild_1 != null) {
        if (serverBuild != null) {
            if ((pageBuild_1 !== "") && (serverBuild !== "")) {
                matchResult = 0;
                page_1 = pageBuild_1;
                server_1 = serverBuild;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return page_1 !== server_1;
        default:
            return false;
    }
}

/**
 * A check is due once the last one is at least `throttleMs` old.
 */
export function isDue(lastCheckedAtMs_1, nowMs_1) {
    return (nowMs_1 - lastCheckedAtMs_1) >= throttleMs;
}

function nowMs() {
    return toFloat64(toUnixTimeMilliseconds(Clock_system.UtcNow()));
}

let lastCheckedAtMs = nowMs();

function pageBuild() {
    const value = window.__APP_BUILD__;
    if (typeof value === "string") {
        const build = value;
        return build;
    }
    else {
        return undefined;
    }
}

function fetchServerBuild() {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => ((fetch("/api/build", {
        cache: "no-store",
    })).then((_arg) => {
        const response = _arg;
        return response.ok ? ((response.text()).then((_arg_1) => (Promise.resolve(_arg_1.trim())))) : (Promise.resolve(undefined));
    }))));
    return pr.catch((_arg_2) => undefined);
}

/**
 * Fetches /api/build at most once per `throttleMs` and reloads the page when the build changed.
 * Resolves true when the page is reloading.
 */
export function reloadIfStale() {
    const now = nowMs();
    if (isDue(lastCheckedAtMs, now)) {
        lastCheckedAtMs = now;
        const pr = fetchServerBuild();
        return pr.then((serverBuild) => {
            const stale = needsReload(pageBuild(), serverBuild);
            if (stale) {
                window.location.reload();
            }
            return stale;
        });
    }
    else {
        return Promise.resolve(false);
    }
}

/**
 * Runs `cmd` once `check` resolves, unless it reports the page is reloading: a stale bundle must not
 * call the new server's RPCs, whose positional MsgPack records it would misread.
 */
export function afterBuildCheck(check, cmd) {
    return singleton((dispatch) => {
        let pr;
        (pr = check(), pr.then((reloading) => {
            if (!reloading) {
                const enumerator = getEnumerator(cmd);
                try {
                    while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
                        enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]()(dispatch);
                    }
                }
                finally {
                    disposeSafe(enumerator);
                }
            }
        }));
    });
}

//# sourceMappingURL=BuildCheck.js.map
